import OptionSelect from './OptionSelect';
import React, { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
var floorToOption = function (floor) { return ({
    value: '' + floor.id,
    label: floor.title,
    disabled: false,
}); };
var FloorSelect = function (props) {
    var floorPlanStore = useContext(MobXProviderContext).floorPlanStore;
    var onChange = props.onChange;
    var nonExistingValue = {
        value: '-',
        label: '-',
        disabled: true,
    };
    var defaultValue = floorPlanStore.currentFloor ? floorToOption(floorPlanStore.currentFloor) : nonExistingValue;
    var options = floorPlanStore.floors.length > 0 ? floorPlanStore.floors.map(floorToOption) : [nonExistingValue];
    var setCurrentFloor = function (floorValue) {
        var floor = floorPlanStore.floors.find(function (f) { return floorValue === '' + f.id; });
        if (floor) {
            floorPlanStore.setCurrentFloor(floor);
        }
    };
    return (React.createElement("div", { style: { zIndex: 100 } },
        React.createElement(OptionSelect, { options: options, onChange: function (selected) {
                setCurrentFloor(selected.value);
                if (onChange) {
                    onChange(selected);
                }
            }, value: defaultValue })));
};
export default FloorSelect;
//# sourceMappingURL=FloorSelect.js.map